import React from 'react';

import './styles.css';

const Header = () => <header>Max Photo Studio!</header>;

export default Header;
